<template><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(0, -.5)">
        <path d="M16.3395 12.201L9.26351 5.12495C9.0969 4.95835 8.82971 4.95835 8.6631 5.12495C8.4965 5.29156 8.4965 5.55876 8.6631 5.72536L15.4373 12.4996L8.6631 19.2739C8.49649 19.4405 8.49649 19.7077 8.6631 19.8743C8.74483 19.956 8.85485 20 8.96173 20C9.06861 20 9.17863 19.9591 9.26036 19.8743L16.3364 12.7982C16.503 12.6348 16.503 12.3644 16.3395 12.201Z"/>
    </g>
</svg>
</template>